import * as angular from 'angular';
import * as _ from 'lodash';

import { IApprovalStrategy, ComponentDefinition, JustificationLevel, AutoApprovalMethod, TimeUnit, Group } from '../../../models';
import { guidEmpty } from '../../../common/constants';
import { IStoreService, ILoggerService, } from '../../../services';
import { StoreElement } from '../../../stateManagement';

interface ApprovalStrategyVm extends IApprovalStrategy {
    // strategy: IApprovalStrategy;
    groups: Group[];
}

class ApprovalStrategiesTableController implements angular.IComponentController, angular.IOnDestroy {
    canSelect: boolean;
    isLoading: boolean;
    isEditMode: boolean;
    strategies: ApprovalStrategyVm[];
    selectedStrategy: ApprovalStrategyVm;

    private _unsubscribe: () => void;

    static $inject = [
        '$translate',
        'storeService',
        'loggerService'
    ];

    constructor(
        private _$translate: angular.translate.ITranslateService,
        private _storeService: IStoreService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this._unsubscribe = this._storeService.register(store => {
            this.isLoading = store.approvalStrategies.isLoading || store.groups.isLoading;
            const strategies = _.values<IApprovalStrategy>(store.approvalStrategies.dictionary);
            const groups = _.values<Group>(store.groups.dictionary);
            this.strategies = strategies
                .filter(s => s.guid !== guidEmpty)
                .map(s => {
                    const vm = Object.assign({}, s, {groups: groups.filter(g => g.approvalStrategyGuid === s.guid)});
                    return vm;
                    // return {
                    //     strategy: (Object as any).assign({}, s),
                    //     groups: groups.filter(g => g.approvalStrategyGuid === s.guid)
                    // } as ApprovalStrategyVm;
                });
            if (this.strategies.length) {
                this.selectedStrategy = this.selectedStrategy
                    ? _.find(this.strategies, s => s.guid === this.selectedStrategy.guid)
                    : this.strategies[0];
            }
        }, [StoreElement.ApprovalStrategies, StoreElement.Groups]);
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    create() {
        this.isLoading = true;
        const newStrategy: IApprovalStrategy = {
            guid: guidEmpty,
            name: 'Strategy',
            approbationStrategyLevelCollection: [
                {
                    level: 0,
                    userCollection: [],
                    roleCollection: [],
                    justificationLevel: JustificationLevel.Never,
                    autoApprovalMethod: AutoApprovalMethod.None,
                    autoApprovalDelay: { interval: 0, intervalTimeUnit: TimeUnit.Day }
                }
            ],
            undoApproval: false,
            allowInFuture: false
        };
        this._storeService.dispatchers().approvalStrategy.create(newStrategy)
            .finally(() => this.isLoading = false);
    }

    duplicate(strategy: IApprovalStrategy): void {
        this.isLoading = true;
        const newStrategy: IApprovalStrategy = angular.copy(strategy);
        newStrategy.guid = guidEmpty;
        this._storeService.dispatchers().approvalStrategy.create(newStrategy)
        .finally(() => this.isLoading = false);
    }

    delete(guid: string): void {
        this.isLoading = true;
        this._storeService.dispatchers().approvalStrategy.delete(guid)
            .then(() => {
                if (this.selectedStrategy.guid === guid) {
                    this.selectedStrategy = null;
                }
            })
            .finally(() => this.isLoading = false);
    }

    select(vm: ApprovalStrategyVm) {
        if (!this.canSelect) {
            const msg = this._$translate.instant('Save or cancel changes before selecting another strategy');
            this._loggerService.logWarning(msg);
        } else {
            this.selectedStrategy = vm;
        }
    }
}

export const wtApprovalStrategiesTable: ComponentDefinition = {
    componentId: 'wtApprovalStrategiesTable',
    controller: ApprovalStrategiesTableController,
    controllerAs: 'vm',
    template: require('./approvalStrategiesTable.component.html'),
    bindings: {
        isEditMode: '=',
        selectedStrategy: '=?',
        canSelect: '=?'
    }
};